<div *ngIf="!fieldTemplate; else customTemplate" [id]="field.field + '_Item'" class="inputItem">
    <ng-container *ngIf="(inputFormControl?.statusChanges | async) || {}">
        <mat-form-field appearance="fill"
                        [color]="field.color"
                        [style.pointer-events]="inputFormControl.disabled ? 'none' : null" #item [style.z-index]="index">
            <mat-label [class]="field.field + '_Label'">{{field.label | translate}}</mat-label>
            <input *ngIf="field.dateOptions?.dateFormats; else normalDate" autocomplete="off" matInput [formControl]="inputFormControl" [matDatepicker]="picker" [readonly]="field.readonly"
                    [matDatepickerFilter]="field.dateOptions?.dateFilter" [min]="field.dateOptions?.minDate || field?.minDate" [max]="field.dateOptions?.maxDate || field?.maxDate" [placeholder]="placeholder"
                    [dateFormats]="field.dateOptions?.dateFormats" [id]="field.field"/>
            <ng-template #normalDate>
                <input autocomplete="off" matInput [formControl]="inputFormControl" [matDatepicker]="picker" [readonly]="field.readonly"
                    [matDatepickerFilter]="field.dateOptions?.dateFilter" [min]="field.dateOptions?.minDate || field?.minDate" [max]="field.dateOptions?.maxDate || field?.maxDate" [placeholder]="placeholder" [id]="field.field"/>
            </ng-template>

            <mat-datepicker-toggle matSuffix [for]="picker" [style.pointer-events]="field.readonly ? 'none' : 'inherit'"></mat-datepicker-toggle>
            <mat-datepicker #picker [touchUi]="field.touch" [dateClass]="field.dateOptions?.dateClass"></mat-datepicker>
            <div matSuffix class="matSuffix">
                <button *ngIf="field.withClearButton" type="button" tabindex="-1" mat-icon-button (click)="$event.stopPropagation(); inputFormControl.patchValue('')">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-generic-input-slot [control]="inputFormControl" [field]="field" [fieldAddonTemplates]="fieldAddonTemplates$ | async"></mat-generic-input-slot>
            </div>
            <mat-error *ngIf="!(field.selectSearchData?.selectData?.options | async)?.length">
                <mat-generic-input-hint type="error" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
            </mat-error>
            <mat-hint>
                <mat-generic-input-hint type="combined" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
            </mat-hint>
        </mat-form-field>
        <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                          *ngIf="(inputFormControl?.statusChanges | async) === 'PENDING' || inputFormControl?.status === 'PENDING'"></mat-progress-bar>
    </ng-container>
</div>

<ng-template #customTemplate>
    <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: inputFormControl, index: index }"></ng-container>
</ng-template>
